import { apiToken, apiBasic, apiGet } from "./requests";

export const getCustomerInfo = (query) => {
  let path = "get-customer-info";
  return apiGet(path, query);
};

export const editCustomerInfo = (query) => {
  let path = "edit-customer-info";
  return apiBasic(query, path, "patch");
};

export const changeCustomerPassword = (query) => {
  let path = "change-customer-password";
  return apiToken(query, path, "post");
};

export const addCustomerShippingAddress = (query) => {
  let path = "add-customer-shipping-address";
  return apiBasic(query, path, "post");
};

export const addCustomerBillingAddress = (query) => {
  let path = "add-customer-billing-address";
  return apiBasic(query, path, "post");
};

export const editCustomerShippingAddress = (query) => {
  let path = "edit-customer-shipping-address";
  return apiBasic(query, path, "patch");
};

export const editCustomerBillingAddress = (query) => {
  let path = "edit-customer-billing-address";
  return apiBasic(query, path, "patch");
};

export const deleteCustomerShippingAddress = (query) => {
  let path = "delete-customer-shipping-address";
  return apiBasic(query, path, "delete");
};

export const deleteCustomerBillingAddress = (query) => {
  let path = "delete-customer-billing-address";
  return apiBasic(query, path, "delete");
};

export const getCustomerOrdersHistory = () => {
  let path = "get-customer-orders-history";
  return apiGet(path);
};

export const getLegalPolicies = () => {
  let path = "legal-policies";
  return apiGet(path);
};
